export default {
  data () {
    return {
      isHeaderOpen: false,
    }
  },
  methods: {
    goTop () {
      document.documentElement.scrollTop = 0
      this.isHeaderClose()
    },
    goPageAnchor () {
      this.isHeaderOpen = false
      document.documentElement.classList.remove('header-nav-show')
      this.$root.$emit('router:change')
    },
    isHeaderClose () {
      this.isHeaderOpen = false
      document.documentElement.classList.remove('header-nav-show')
    },
  }
}
